<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import PageGrid16 from '$lib/storyblok/components/pageGrid16.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			slot_1: ISbStoryData['content'][];
			slot_2: ISbStoryData['content'][];
			slot_3: ISbStoryData['content'][];
			slot_4: ISbStoryData['content'][];
			slot_5: ISbStoryData['content'][];
			slot_5_5: ISbStoryData['content'][];
			slot_6: ISbStoryData['content'][];
			slot_7: ISbStoryData['content'][];
			slot_8: ISbStoryData['content'][];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="bg-white pb-16 pt-2 max-lg:px-5 lg:pb-15">
	<PageGrid16 gridClass="gap-y-3 lg:gap-y-4">
		<div class="col-start-1 col-end-3 flex gap-4 max-lg:flex-col lg:col-start-2 lg:col-end-9">
			<div class="flex flex-col gap-4 lg:flex-1">
				{#if content.slot_1 && content.slot_1.length > 0}
					<Blok content={content.slot_1[0]} />
				{/if}
				{#if content.slot_2 && content.slot_2.length > 0}
					<Blok content={content.slot_2[0]} />
				{/if}
			</div>
			<div class="flex flex-col gap-4 lg:flex-1">
				{#if content.slot_3 && content.slot_3.length > 0}
					<Blok content={content.slot_3[0]} />
				{/if}
				{#if content.slot_4 && content.slot_4.length > 0}
					<Blok content={content.slot_4[0]} />
				{/if}
			</div>
		</div>
		<div class="col-start-3 col-end-5 flex gap-4 max-lg:flex-col lg:col-start-9 lg:col-end-[16]">
			<div class="flex flex-col gap-4 lg:flex-1">
				{#if content.slot_5 && content.slot_5.length > 0}
					<Blok content={content.slot_5[0]} />
				{/if}
				<div class="flex flex-col-reverse gap-4 lg:flex-col">
					{#if content.slot_5_5 && content.slot_5_5.length > 0}
						<Blok content={content.slot_5_5[0]} />
					{/if}
					{#if content.slot_6 && content.slot_6.length > 0}
						<Blok content={content.slot_6[0]} />
					{/if}
				</div>
			</div>
			<div class="flex flex-col-reverse gap-4 lg:flex-1 lg:flex-col">
				{#if content.slot_7 && content.slot_7.length > 0}
					<Blok content={content.slot_7[0]} />
				{/if}
				{#if content.slot_8 && content.slot_8.length > 0}
					<Blok content={content.slot_8[0]} delay={300} />
				{/if}
			</div>
		</div>
	</PageGrid16>
</section>
